export default "{\n    \"generic\": \"Something went wrong.\"\n}\n"